import { NASStatus } from '@websky/graphql';
import * as React from 'react';
const LoungeReducer = (state = [], action) => {
    if (action.type === 'add') {
        const { payload } = action;
        if (!state.find(item => item.travellerId === payload.travellerId && item.product.id === payload.product.id)) {
            return [
                ...state,
                Object.assign({}, payload)
            ];
        }
    }
    else if (action.type === 'remove') {
        const { payload } = action;
        return state.filter(item => item.travellerId !== payload.travellerId || item.product.id !== payload.product.id);
    }
    else if (action.type === 'clearOnSegment') {
        const { payload: segmentId } = action;
        return state.filter(item => item.product.segmentId.toString() !== segmentId);
    }
    return state;
};
export const useEveryPortState = (selectedServices, everyPortServices) => {
    const [state, dispatch] = React.useReducer(LoungeReducer, selectedServices, selectedServices => {
        const state = [];
        selectedServices.forEach(service => {
            const product = everyPortServices.find(everyPort => everyPort.id === service.product.id), fare = product.fares.find(fare => fare.id === service.fare.id);
            service.orders.forEach(order => {
                state.push({
                    travellerId: order.travellers.id,
                    product: product,
                    active: true,
                    fare: fare,
                    status: order.status
                });
            });
        });
        return state;
    });
    const setTraveller = (travellerId, product, fare) => {
        dispatch({
            type: 'add',
            payload: {
                travellerId,
                product,
                fare,
                status: NASStatus.New
            }
        });
    };
    const removeTraveller = (travellerId, product, fare) => {
        dispatch({
            type: 'remove',
            payload: {
                travellerId,
                product,
                fare
            }
        });
    };
    const clearSegment = (segmentId) => {
        dispatch({
            type: 'clearOnSegment',
            payload: segmentId
        });
    };
    return {
        state,
        setTraveller,
        removeTraveller,
        clearSegment
    };
};
